import React from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { loadPool, loadPoolAsync, loadPoolSummaryAsync } from '../../../actions/poolDetails'
import Shifts from './shifts/index'
import DeliveryHours from './deliveryHours/index'
import Restaurants from './restaurants/index'
import Logs from './logs'
import Wrapper from '../../../components/wrapper'
import PropTypes from 'prop-types'
import PoolSummary from './summary'
import PoolInfo from './info'
import { showModal } from '../../../actions/modal'
import { DELETE_POOL } from '../../../actions/poolDelete'
import { SYNC_PARTNER_RESTAURANT_DETAILS } from '../../../actions/syncPartnerRestaurantsDetails'
import { isMagicEnabledFromSearch } from '../../../helpers/tenant'
import { HIDE_POOL_SHIFTS } from '../../../constants/featureFlags'

export class PoolDetails extends React.Component {

  componentDidMount() {
    this.props.loadPoolAsync({
      id: this.props.poolId
    })

    this.props.loadPoolSummaryAsync({
      id: this.props.poolId
    })
  }

  render() {
    const infoPath = {
      pathname: `/pools/${this.props.poolId}/info`,
      search: this.props.locationSearch
    }
    const shiftsPath = {
      pathname: `/pools/${this.props.poolId}/shifts/${this.props.activeDate}`,
      search: this.props.locationSearch
    }
    const restaurantsPath = {
      pathname: `/pools/${this.props.poolId}/restaurants`,
      search: this.props.locationSearch
    }
    const deliveryHoursPath = {
      pathname: `/pools/${this.props.poolId}/deliveryHours`,
      search: this.props.locationSearch
    }
    const logsPath = {
      pathname: `/pools/${this.props.poolId}/logs`,
      search: this.props.locationSearch
    }
    const summaryPath = {
      pathname: `/pools/${this.props.poolId}/summary`,
      search: this.props.locationSearch
    }

    let tab
    switch (this.props.selectedTab) {
    case 'shifts':
      tab = <Shifts poolId={this.props.poolId} activeDate={this.props.activeDate} />
      break
    case 'restaurants':
      tab = <Restaurants id={this.props.poolId} />
      break
    case 'logs':
      tab = <Logs id={this.props.poolId} />
      break

    case 'deliveryHours':
      tab = <DeliveryHours id={this.props.poolId} />
      break

    case 'summary':
      tab = <PoolSummary id={this.props.poolId} />
      break

    case 'info':
      tab = <PoolInfo id={this.props.poolId} />
      break

    default:
      tab = <span>asas..</span>
      break
    }

    return <div>
      <Wrapper title={this.props.poolName}
        isAdminButtonsVisible={this.props.isAdminButtonsVisible}
        showDeletePoolModal={() => this.props.showModal(DELETE_POOL)}
        showSyncRestaurantDetailsModal={() => this.props.showModal(SYNC_PARTNER_RESTAURANT_DETAILS)}
      >
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <NavLink id="navPoolInfo" className="nav-link" activeClassName={'active'} to={infoPath}>Info</NavLink>
          </li>
          { !this.props.isRiskLevelBased && !HIDE_POOL_SHIFTS && <li className="nav-item">
            <NavLink id="navShifts" className="nav-link" exact activeClassName={'active'} to={shiftsPath}
              isActive={(match, location) => location.pathname === `/pools/${this.props.poolId}/shifts/${this.props.activeDate}`} >Shifts</NavLink>
          </li>}
          <li className="nav-item">
            <NavLink id="navRestaurants" className="nav-link" activeClassName={'active'} to={restaurantsPath}>Restaurants</NavLink>
          </li>
          <li className="nav-item">
            <NavLink id="navDeliveryHours" className="nav-link" activeClassName={'active'} to={deliveryHoursPath}>Hours</NavLink>
          </li>
          <li className="nav-item">
            <NavLink id="navLogs" className="nav-link" activeClassName={'active'} to={logsPath}>Logs</NavLink>
          </li>
          <li className="nav-item">
            <NavLink id="navSummary" className="nav-link" activeClassName={'active'} to={summaryPath}>Summary</NavLink>
          </li>
        </ul>
        <div>
          {tab}
        </div>
      </Wrapper>
    </div>
  }
}

const mapStateToProps = (state, props) => {
  const locationSearch = state.router.location.search || ''
  const isAdminButtonsVisible = isMagicEnabledFromSearch(locationSearch)
  return {
    ...props,
    poolId: props.match.params.id,
    activeDate: props.match.params.activeDate,
    locationSearch: locationSearch,
    poolName: state.poolDetails.poolName,
    isLoading: state.poolDetails.isLoading,
    displayEditMode: state.poolDetails.restaurantDisplayEditMode,
    isAdminButtonsVisible: isAdminButtonsVisible,
    isRiskLevelBased: state.poolDetails.poolSummary.poolMode === 'RiskLevelBased'
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  loadPool,
  loadPoolAsync,
  loadPoolSummaryAsync,
  showModal
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PoolDetails)

PoolDetails.propTypes = {
  poolId: PropTypes.string.isRequired,
  selectedTab: PropTypes.string.isRequired,
  poolName: PropTypes.string.isRequired,
  loadPoolAsync: PropTypes.func.isRequired,
  loadPoolSummaryAsync: PropTypes.func.isRequired,
  activeDate: PropTypes.string,
  locationSearch: PropTypes.string,
  showModal: PropTypes.func,
  isAdminButtonsVisible: PropTypes.bool,
  isRiskLevelBased: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/containers/pools/details/index.js